import { useEffect } from 'react'
import useAudioSettingsStoreActions from './useAudioSettingsStoreActions'

export default function useAudioSettingsStoreEffects() {
    const { load } = useAudioSettingsStoreActions()

    useEffect(() => {
        load()
    }, [])
}
